import {SimpleGrid, Card, Flex} from "@mantine/core";
import {PackageIcon} from "@phosphor-icons/react";
import Icon from "../../components/Icon/Icon.tsx";
import IconMap from "../../components/Icon/IconMap.ts";
import {New} from "../subscription/Comparison.jsx";


export default function FeatureList() {

    return (
    <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="xl">
        <FeatureCard title="Bounty Hunting" icon={<Icon icon={IconMap.BountyHunting}/>}
                     description="Manage your contracts, triangulate target positions and find the nearest tavern to turn them in."/>
        <FeatureCard title="Hyper Routes" icon={<Icon icon={IconMap.HyperRoutes}/>} description="Find the fastest way to move between systems"/>
        <FeatureCard title="Cargo Calculators" icon={<PackageIcon size={32} />}
                     description="Do you have stuff to move around? Do you want to optimize what your carrier can fit inside?"/>
        <FeatureCard title="Vision Simulator" icon={<Icon icon={IconMap.Vision}/>}
                     description="Simulate your sensor reach, make sure no one can hide from you!"/>
        <FeatureCard title={<>Interactive Map</>} icon={<Icon icon={IconMap.Galaxy}/>}
                     description="Get a better view of the galaxy, highlight systems and add overlays to visualize what you need"/>
        <FeatureCard title={<>Asteroid Prospecting<New/></>} icon={<Icon icon={IconMap.AsteroidMining}/>}
                     description="Keep track of what you have found, where to scan and share the result with your friends"/>
    </SimpleGrid>
    );
}

const FeatureCard = ({title, icon, description}) => {
    return (
        <div className="col-12 sm:col-6 md:col-4 mb-4 px-5">
            <Card shadow="md" p="md" withBorder style={{height: '100%'}}>
                <Flex justify="center" align="center">
                    <span style={{padding: '0.5rem', marginBottom: '0.5rem', display: 'inline-block', backgroundColor: 'var(--mantine-color-dark-5)', borderRadius: '10px'}}>
                        <i style={{fontSize: '2rem', color: 'var(--mantine-color-forge-5)', display: 'flex', padding: 4}}>{icon}</i>
                    </span>
                </Flex>

                <div style={{fontSize: '1.25rem', marginBottom: '0.75rem', fontWeight: 500}}>{title}</div>
                <span style={{color: 'var(--mantine-color-dark-2)', lineHeight: 1.75}}>{description}</span>
            </Card>
        </div>
    )
}
